import { createEmotionCache } from '@mantine/core';

export const mantineCache = createEmotionCache({
  key: 'mantine',
  prepend: true,
});
